import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { ApiKeysV1Item } from './api-keys-v1-item';
import { messages } from './messages';
import style from './style.module.less';

/**
 * This component renders the section to list and create API keys from V2
 * @param {object} props
 * @param {Array<import('../../types/api-keys').APIKeysV1>} [props.v1ApiKeys]
 * @param {(apiKeyId: number) => void} props.onDeleteClick
 * @returns {JSX.Element} The rendered component.
 */
export const ApiKeysV1 = ({ v1ApiKeys, onDeleteClick }) => {
  if (v1ApiKeys?.length) {
    return (
      <table className={style['api-keys-v1-table']}>
        <thead>
          <tr>
            <th className={style['api-keys-v1-table-head-th']}>
              <Text textType={TextType.Label} value={messages.tableHeadToken} />
            </th>
            <th className={style['api-keys-v1-table-head-th']}>
              <Text textType={TextType.Label} value={messages.tableHeadCreatedDate} />
            </th>
            <th className={style['api-keys-v1-table-head-th']}>
              <Text textType={TextType.Label} value={messages.tableHeadExpiration} />
            </th>
            <th className={style['api-keys-v1-table-head-th']} />
            <th className={style['api-keys-v1-table-head-th']} />
          </tr>
        </thead>
        <tbody>
          {v1ApiKeys?.map((v1ApiKey, index) => (
            <ApiKeysV1Item key={index} onDeleteClick={onDeleteClick} v1ApiKey={v1ApiKey} />
          ))}
        </tbody>
      </table>
    );
  }

  return <></>;
};
